import { useEffect } from "react";
import { Link } from "react-router-dom";

const highlights = [
  {
    icon: "ri-spy-line",
    title: "El Misterio de una Identidad",
    desc: "¿Fue un golpe milimétricamente planeado o una trágica confusión de identidad? Acompaña a \"Lucho\" a desentrañar las señales ignoradas y la verdad detrás de su captura."
  },
  {
    icon: "ri-mental-health-line",
    title: "La Batalla en la Oscuridad",
    desc: "Descubre cómo la mente humana sobrevive a la soledad absoluta, al hambre y al miedo constante, encontrando en una cruz de madera y una oración el único hilo que lo mantuvo conectado a la vida."
  },
  {
    icon: "ri-heart-pulse-line",
    title: "El Calvario Invisible",
    desc: "Por primera vez, siente la angustia de la \"cruel negociación\" desde ambos lados: la agonía del prisionero y el sacrificio heroico de una familia que se negó a perderlo."
  },
  {
    icon: "ri-sun-line",
    title: "Un Mensaje de Resiliencia",
    desc: "Más allá del trauma, este libro es una lección magistral sobre el perdón y el \"nuevo amanecer\" que surge después de haber rozado la muerte."
  }
];

export default function LibroPage() {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  return (
    <div className="min-h-screen" style={{ background: "#F9F6EF" }}>

      {/* Navbar simple */}
      <nav
        className="fixed top-0 left-0 w-full z-50"
        style={{
          background: "rgba(0,29,62,0.97)",
          backdropFilter: "blur(12px)",
          borderBottom: "1px solid rgba(212,175,55,0.2)"
        }}
      >
        <div className="max-w-7xl mx-auto px-6 md:px-16 flex items-center justify-between h-16 md:h-20">
          <Link to="/" className="flex items-center gap-2 cursor-pointer">
            <img
              src="https://static.readdy.ai/image/be4637b51fa2c7a7dcdb39fcd9b97fd2/5faa96864b94acad4f6acb77240d3382.png"
              alt="El Secuestro de Lucho"
              className="h-10 md:h-12 w-auto object-contain"
            />
          </Link>
          <div className="flex items-center gap-4">
            <Link
              to="/"
              className="text-sm font-medium transition-colors duration-300 cursor-pointer whitespace-nowrap hidden md:block"
              style={{ color: "rgba(255,255,255,0.75)" }}
            >
              ← Volver al inicio
            </Link>
            <a
              href="https://www.amazon.com"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 text-sm font-semibold transition-all duration-300 whitespace-nowrap cursor-pointer"
              style={{
                background: "linear-gradient(135deg, #D4AF37, #F0D060)",
                color: "#002D62",
                padding: "10px 22px",
                borderRadius: "50px"
              }}
            >
              <i className="ri-amazon-fill" />
              Comprar
            </a>
          </div>
        </div>
      </nav>

      {/* Hero del libro */}
      <section
        className="relative pt-20 pb-0 overflow-hidden"
        style={{
          background: "linear-gradient(160deg, #001D3E 0%, #002D62 50%, #001020 100%)"
        }}
      >
        {/* Partículas decorativas */}
        <div className="absolute inset-0 overflow-hidden pointer-events-none">
          {[...Array(18)].map((_, i) => (
            <div
              key={i}
              className="absolute rounded-full"
              style={{
                width: `${Math.random() * 4 + 2}px`,
                height: `${Math.random() * 4 + 2}px`,
                background: "rgba(212,175,55,0.4)",
                top: `${Math.random() * 100}%`,
                left: `${Math.random() * 100}%`,
                animation: `float ${3 + Math.random() * 4}s ease-in-out infinite`,
                animationDelay: `${Math.random() * 3}s`
              }}
            />
          ))}
        </div>

        <div className="max-w-6xl mx-auto px-6 md:px-16 py-16 md:py-24 flex flex-col lg:flex-row items-center gap-12 lg:gap-20 relative z-10">

          {/* Portada del libro */}
          <div className="flex-shrink-0 flex flex-col items-center">
            <div
              className="relative"
              style={{
                filter: "drop-shadow(0 30px 60px rgba(0,0,0,0.7))",
                transform: "perspective(800px) rotateY(-8deg)"
              }}
            >
              {/* Borde dorado */}
              <div
                className="absolute inset-0 rounded-xl z-0"
                style={{
                  background: "linear-gradient(135deg, #D4AF37, #F0D060, #D4AF37)",
                  padding: "3px",
                  borderRadius: "12px"
                }}
              />
              <div
                className="relative rounded-xl overflow-hidden z-10"
                style={{ width: "280px", height: "400px", border: "3px solid #D4AF37" }}
              >
                <img
                  src="https://storage.readdy-site.link/project_files/951df6da-f1cc-404a-8f5e-9c6747405f5d/a26ecb0d-3f7a-4d8c-a849-0bdff8405e06_Diseno-sin-titulo-6.png?v=f7d409cfa6533b50a15429b92b3e7796"
                  alt="El Secuestro de Lucho - Portada"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              {/* Badge */}
              <div
                className="absolute -top-3 -right-3 z-20 rounded-full w-16 h-16 flex items-center justify-center text-center"
                style={{ background: "linear-gradient(135deg, #D4AF37, #F0D060)", boxShadow: "0 4px 15px rgba(212,175,55,0.5)" }}
              >
                <span className="text-xs font-black leading-tight" style={{ color: "#002D62" }}>HISTORIA<br />REAL</span>
              </div>
            </div>

            {/* CTA bajo la portada */}
            <a
              href="https://www.amazon.com"
              target="_blank"
              rel="noopener noreferrer"
              className="mt-8 inline-flex items-center gap-3 font-bold text-base transition-all duration-300 cursor-pointer whitespace-nowrap"
              style={{
                background: "linear-gradient(135deg, #D4AF37, #F0D060)",
                color: "#002D62",
                padding: "14px 32px",
                borderRadius: "50px",
                boxShadow: "0 8px 30px rgba(212,175,55,0.4)"
              }}
              onMouseEnter={e => (e.currentTarget as HTMLAnchorElement).style.transform = "translateY(-3px)"}
              onMouseLeave={e => (e.currentTarget as HTMLAnchorElement).style.transform = "translateY(0)"}
            >
              <i className="ri-amazon-fill text-xl" />
              Consíguelo en Amazon
            </a>
          </div>

          {/* Texto principal */}
          <div className="flex-1 text-center lg:text-left">
            {/* Eyebrow */}
            <div className="inline-flex items-center gap-2 mb-5">
              <div className="h-px w-8" style={{ background: "#D4AF37" }} />
              <span className="text-xs font-bold tracking-widest uppercase" style={{ color: "#D4AF37" }}>Testimonio Real · Thriller Espiritual</span>
              <div className="h-px w-8" style={{ background: "#D4AF37" }} />
            </div>

            <h1 className="font-black leading-tight mb-2" style={{ fontSize: "clamp(2rem, 5vw, 3.5rem)", color: "#FFFFFF" }}>
              EL SECUESTRO
            </h1>
            <h2 className="font-black leading-tight mb-6" style={{ fontSize: "clamp(2.5rem, 6vw, 4.5rem)", color: "#D4AF37", textShadow: "0 0 40px rgba(212,175,55,0.4)" }}>
              DE LUCHO
            </h2>

            {/* Pregunta gancho */}
            <p className="text-lg md:text-xl font-semibold mb-4 italic" style={{ color: "rgba(255,255,255,0.9)" }}>
              ¿Planificación o Equivocación?
            </p>
            <p className="text-base md:text-lg mb-6" style={{ color: "rgba(255,255,255,0.7)", lineHeight: "1.8" }}>
              El relato real que te hará cuestionar la fragilidad de la libertad.
            </p>

            {/* Datos clave */}
            <div className="flex flex-wrap gap-4 justify-center lg:justify-start mb-8">
              {[
                { icon: "ri-time-line", text: "67 días de cautiverio" },
                { icon: "ri-shield-cross-line", text: "Fe inquebrantable" },
                { icon: "ri-question-mark", text: "Una pregunta que lo cambió todo" }
              ].map((item, i) => (
                <div
                  key={i}
                  className="flex items-center gap-2 px-4 py-2 rounded-full text-sm font-medium"
                  style={{ background: "rgba(212,175,55,0.12)", border: "1px solid rgba(212,175,55,0.3)", color: "#D4AF37" }}
                >
                  <i className={item.icon} />
                  {item.text}
                </div>
              ))}
            </div>

            {/* Intro */}
            <p className="text-base leading-relaxed" style={{ color: "rgba(255,255,255,0.65)", maxWidth: "560px" }}>
              Imagina que un día despiertas en tu rutina como empresario y ganadero, rodeado de tu familia y tu tierra, y al siguiente, el mundo se desvanece tras las paredes de barro de un "cambuche" en la selva colombiana.
            </p>
          </div>
        </div>

        {/* Wave bottom */}
        <div className="w-full overflow-hidden leading-none" style={{ height: "60px" }}>
          <svg viewBox="0 0 1440 60" preserveAspectRatio="none" className="w-full h-full">
            <path d="M0,60 C360,0 1080,0 1440,60 L1440,60 L0,60 Z" fill="#F9F6EF" />
          </svg>
        </div>
      </section>

      {/* Sinopsis completa */}
      <section className="py-16 md:py-24" style={{ background: "#F9F6EF" }}>
        <div className="max-w-4xl mx-auto px-6 md:px-16">
          <div className="text-center mb-12">
            <div className="inline-flex items-center gap-2 mb-4">
              <div className="h-px w-10" style={{ background: "#D4AF37" }} />
              <span className="text-xs font-bold tracking-widest uppercase" style={{ color: "#D4AF37" }}>Sinopsis</span>
              <div className="h-px w-10" style={{ background: "#D4AF37" }} />
            </div>
            <h3 className="text-2xl md:text-3xl font-black" style={{ color: "#002D62" }}>
              Una historia que no podrás soltar
            </h3>
          </div>

          <div
            className="rounded-2xl p-8 md:p-12 relative overflow-hidden"
            style={{ background: "#FFFFFF", border: "1px solid rgba(212,175,55,0.2)" }}
          >
            {/* Comilla decorativa */}
            <div
              className="absolute top-6 left-8 text-8xl font-black leading-none select-none"
              style={{ color: "rgba(212,175,55,0.1)", fontFamily: "Georgia, serif" }}
            >
              "
            </div>

            <div className="relative z-10 space-y-5 text-base md:text-lg leading-relaxed" style={{ color: "#3D3D3D" }}>
              <p>
                En <strong style={{ color: "#002D62" }}>"EL SECUESTRO DE LUCHO"</strong>, Carlos Alberto Díaz Martínez abre su corazón para narrar el testimonio crudo de su cautiverio a manos de la guerrilla. Pero este no es solo un recuento de hechos; es un <strong>thriller psicológico y espiritual de la vida real</strong> que te mantendrá en vilo desde la primera página.
              </p>
              <p>
                No es solo un libro sobre un secuestro; es una <strong>guía de supervivencia espiritual</strong> para cualquier persona que enfrente su propia oscuridad.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Por qué leerlo */}
      <section className="py-16 md:py-24" style={{ background: "#FFFFFF" }}>
        <div className="max-w-6xl mx-auto px-6 md:px-16">
          <div className="text-center mb-14">
            <div className="inline-flex items-center gap-2 mb-4">
              <div className="h-px w-10" style={{ background: "#D4AF37" }} />
              <span className="text-xs font-bold tracking-widest uppercase" style={{ color: "#D4AF37" }}>¿Por qué leer esta historia?</span>
              <div className="h-px w-10" style={{ background: "#D4AF37" }} />
            </div>
            <h3 className="text-2xl md:text-3xl font-black" style={{ color: "#002D62" }}>
              Cuatro razones que te cambiarán
            </h3>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {highlights.map((item, i) => (
              <div
                key={i}
                className="rounded-2xl p-7 flex gap-5 transition-all duration-300 cursor-default"
                style={{ background: "#F9F6EF", border: "1px solid rgba(212,175,55,0.15)" }}
                onMouseEnter={e => {
                  (e.currentTarget as HTMLDivElement).style.borderColor = "rgba(212,175,55,0.5)";
                  (e.currentTarget as HTMLDivElement).style.transform = "translateY(-4px)";
                }}
                onMouseLeave={e => {
                  (e.currentTarget as HTMLDivElement).style.borderColor = "rgba(212,175,55,0.15)";
                  (e.currentTarget as HTMLDivElement).style.transform = "translateY(0)";
                }}
              >
                <div
                  className="flex-shrink-0 w-12 h-12 flex items-center justify-center rounded-xl"
                  style={{ background: "linear-gradient(135deg, #D4AF37, #F0D060)" }}
                >
                  <i className={`${item.icon} text-xl`} style={{ color: "#002D62" }} />
                </div>
                <div>
                  <h4 className="font-bold text-base mb-2" style={{ color: "#002D62" }}>{item.title}</h4>
                  <p className="text-sm leading-relaxed" style={{ color: "#666" }}>{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA final */}
      <section
        className="py-20 md:py-28 text-center relative overflow-hidden"
        style={{ background: "linear-gradient(160deg, #001D3E 0%, #002D62 100%)" }}
      >
        <div className="absolute inset-0 overflow-hidden pointer-events-none">
          {[...Array(12)].map((_, i) => (
            <div
              key={i}
              className="absolute rounded-full"
              style={{
                width: `${Math.random() * 3 + 2}px`,
                height: `${Math.random() * 3 + 2}px`,
                background: "rgba(212,175,55,0.35)",
                top: `${Math.random() * 100}%`,
                left: `${Math.random() * 100}%`,
                animation: `float ${3 + Math.random() * 4}s ease-in-out infinite`,
                animationDelay: `${Math.random() * 3}s`
              }}
            />
          ))}
        </div>
        <div className="max-w-2xl mx-auto px-6 relative z-10">
          <p className="text-sm font-bold tracking-widest uppercase mb-4" style={{ color: "#D4AF37" }}>
            Disponible ahora
          </p>
          <h3 className="text-3xl md:text-4xl font-black text-white mb-4">
            67 días que te cambiarán para siempre
          </h3>
          <p className="text-base mb-10" style={{ color: "rgba(255,255,255,0.65)", lineHeight: "1.8" }}>
            Una fe inquebrantable. Una pregunta que lo cambió todo. Una historia que no podrás soltar.
          </p>
          <a
            href="https://www.amazon.com"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-3 font-bold text-lg transition-all duration-300 cursor-pointer whitespace-nowrap"
            style={{
              background: "linear-gradient(135deg, #D4AF37, #F0D060)",
              color: "#002D62",
              padding: "16px 40px",
              borderRadius: "50px",
              boxShadow: "0 8px 40px rgba(212,175,55,0.4)"
            }}
            onMouseEnter={e => (e.currentTarget as HTMLAnchorElement).style.transform = "translateY(-3px)"}
            onMouseLeave={e => (e.currentTarget as HTMLAnchorElement).style.transform = "translateY(0)"}
          >
            <i className="ri-amazon-fill text-2xl" />
            Comprar en Amazon
          </a>
        </div>
      </section>

      <style>{`
        @keyframes float {
          0%, 100% { transform: translateY(0px); opacity: 0.4; }
          50% { transform: translateY(-12px); opacity: 0.8; }
        }
      `}</style>
    </div>
  );
}
